const apiUrl = process.env.VUE_APP_MODE === 'local' ? 'http://localhost:8000/api/' : `${process.env.VUE_APP_API_ENDPOINT}`
const webappUrl = process.env.VUE_APP_MODE === 'local' ? 'http://localhost:8082' : process.env.VUE_APP_WEBAPP_URL

export {
    apiUrl,
    webappUrl
}